import FileProviderViewState from '../store/schema/FileProviderViewState';
import { action } from 'satcheljs';
import { FileProviderType } from '../utils/constants';
import { ProviderLoadStateOption } from '../store/schema/ProviderLoadStateOption';

const add = action('ADD', (providerViewState: FileProviderViewState) => ({
    providerViewState: providerViewState,
}));

const load = action('LOAD', (providers: FileProviderViewState[]) => ({
    providers: providers,
}));

const remove = action('REMOVE', (providerType: FileProviderType) => ({
    providerType: providerType,
}));

const addToRemoving = action('ADD_TO_REMOVING', (providerType: FileProviderType) => ({
    providerType: providerType,
}));

const setLoadState = action('SET_LOAD_STATE', (loadState: ProviderLoadStateOption) => ({
    loadState: loadState,
}));

const removeFromRemoving = action('REMOVE_FROM_REMOVING', (providerType: FileProviderType) => ({
    providerType: providerType,
}));

export { addToRemoving, remove, add, load, setLoadState, removeFromRemoving };
export { default as AttachmentDataProviderType } from 'owa-service/lib/contract/AttachmentDataProviderType';
